/*
 * @Author: Hong.Zhang
 * @Date: 2025-01-17 17:21:51
 * @Description:
 */
import { useState } from 'react';

export default () => {
  const [loading, setLoading] = useState(false);

  return { loading, setLoading };
};
